export function excludePropsHelper(data: any, exclude?: string[]) {
    if (Array.isArray(exclude)) {
        exclude.forEach(fieldName => {
            delete data[fieldName];
            // result[fieldName] = undefined;
        });
    }
    return data;
}
